import { MegaphoneIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { getCurrentUser } from "../services/authService";
import { noticeWizardPath } from "../services/noticeService";
import { can } from "../services/permissions";

/**
 * "Notify affected customers" shortcut into the notice wizard, prefilled with
 * a disruption type and scope. Rendered only for users holding notices.send
 * (the server refuses everybody else, providers included).
 */
export default function NotifyCustomersLink({ type, scope, label, className = "" }) {
  const { t } = useTranslation();

  if (!can(getCurrentUser(), "notices.send")) return null;

  return (
    <Link
      to={noticeWizardPath(type, scope)}
      className={`inline-flex items-center gap-1.5 text-dense font-semibold text-accent-text hover:underline ${className}`}
    >
      <MegaphoneIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
      {label || t("notices.notifyAffected")}
    </Link>
  );
}
